module.exports = __webpack_public_path__ + "img/nora-logo.ccc4d53c.png";